import { setTruck, getTruck } from '@theme/dialed-truck';
import { YmmPicker, truckLabel } from '@theme/dialed-ymm';

/**
 * <dialed-truck-finder data-kit-url="/products/the-dialed-system">: Year → Make → Model → Bed
 * selects and a button. With a buy module on the page it hands the truck over and scrolls there;
 * otherwise it opens the kit with ?truck=&year= so the buy module preselects it.
 */
class DialedTruckFinder extends HTMLElement {
  /** @type {YmmPicker | null} */
  picker = null;

  connectedCallback() {
    let fits = [];
    try {
      fits = JSON.parse(this.querySelector('[data-dialed-trucks]')?.textContent ?? '[]');
    } catch {
      return;
    }
    const get = (/** @type {string} */ name) => /** @type {HTMLSelectElement | null} */ (this.querySelector(`[data-finder="${name}"]`));
    const year = get('year');
    const make = get('make');
    const model = get('model');
    const bed = get('config');
    this.button = /** @type {HTMLButtonElement | null} */ (this.querySelector('[data-finder="go"]'));
    if (!year || !make || !model || !bed || !this.button) return;

    this.picker = new YmmPicker(fits, { year, make, model, bed });
    this.picker.bind(() => this.#render());
    this.button.addEventListener('click', () => this.#go());

    const stored = getTruck();
    this.picker.set(stored ? { year: stored.year, make: stored.make, model: stored.model, fit: stored.fit } : {});
    this.#render();
  }

  #render() {
    if (!this.button || !this.picker) return;
    const fit = this.picker.fit();
    this.button.disabled = !fit;
    this.button.textContent = fit ? this.dataset.readyLabel ?? '' : this.dataset.pickLabel ?? '';
  }

  #go() {
    const fit = this.picker?.fit();
    if (!fit || !this.picker) return;
    const { year } = this.picker.state;
    setTruck({ year, make: fit.make, model: fit.model, fit: fit.handle, label: truckLabel(fit, year) });
    if (document.querySelector('dialed-buy-module')) {
      window.dispatchEvent(new CustomEvent('dialed:select', { detail: { year, make: fit.make, model: fit.model, fit: fit.handle } }));
      return;
    }
    const url = this.dataset.kitUrl;
    if (url) {
      const query = `truck=${encodeURIComponent(fit.handle)}&year=${encodeURIComponent(year)}`;
      window.location.href = `${url}${url.includes('?') ? '&' : '?'}${query}`;
    }
  }
}

if (!customElements.get('dialed-truck-finder')) customElements.define('dialed-truck-finder', DialedTruckFinder);
